import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as crypto from 'crypto-js';

import { JwtService } from './jwt.service';

@Injectable()
export class ApiService {

  key: any;
  date: any;
  iv: any;
  secret: any;
  consommateur: any;
  global: any;
  encrypted: any;
  encryptedFinal: any;

  constructor(
    private http: Http,
    private jwtService: JwtService,
  ) {}

  private setHeaders(): Headers {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    this.setEncryptedKey();
     headersConfig['ApiKey'] = this.encryptedFinal;

    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = this.jwtService.getToken();
    }
    return new Headers(headersConfig);
  }


   private setHeadersFiles(): Headers {
    const headersConfig = {};

    this.setEncryptedKey();
     headersConfig['ApiKey'] = this.encryptedFinal;

    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = this.jwtService.getToken();
    }
    return new Headers(headersConfig);
  }

  private formatErrors(error: any) {
     return Observable.throw(error.json());
  }


  private setEncryptedKey(){
    this.key = crypto.enc.Hex.parse('cd661a34b2a5030e45d82a5f81994317');
    // Non modifiable (doit être mis en constante)
    this.iv =  crypto.enc.Hex.parse('23206deb7eba65b3fbc80a2ffbc53c28');
    // Le secret fournie par la DSI KNÉ pour ce consommateur (doit être mis en constante)
    this.secret = '00e5690416dce80e09aaf84135119b1d';
    // Nom du consommateur (doit être mis en constante)
    this.consommateur = 'FrontEnd';
    // Unix Timestamp de "maintenant" (seul champ dynamique, à régénrer avant chaque demande)
    this.date = Math.round((new Date()).getTime() / 1000);
    // Concaténation du consommateur + de la date + du secret entre balises <kne>
    this.global = '<kne>' + this.consommateur + '-' + this.date + '-' + this.secret + '</kne>';
    // Encryptage avec balise <kne> pour explosion facilitée côté back
    this.encrypted = crypto.AES.encrypt(this.global, this.key, {iv: this.iv});
    // Encodage en Base64
    this.encryptedFinal = this.encrypted.ciphertext.toString(crypto.enc.Base64);
  }

  get(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { headers: this.setHeaders(), search: params })
    .catch(this.formatErrors)
    .map((res: Response) => {
      if(res["_body"].includes('<br />')) res["_body"] = res["_body"].split('<br />')[0];
      return res.json();
    });
  }

  getwp(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    return this.http.get(`${environment.api_wpurl}${path}`, { headers: this.setHeaders(), search: params })
    .catch(this.formatErrors)
    .map((res: Response) => res.json());
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res: Response) => {
      if(res["_body"].includes('<br />')) res["_body"] = res["_body"].split('<br />')[0];
      return res.json();
    });
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res: Response) => res);
  }

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res: Response) => {
      // console.log(res);
      // if(res["_body"].includes('<br />')) res["_body"] = res["_body"].split('<br />')[0];
      return res.json();
    });
  }

   postfile(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      { headers: this.setHeadersFiles() }
    )
    .catch(this.formatErrors)
    .map((res: Response) => { return res.json()} );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts